var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-layout",
    {
      attrs: {
        title: _vm.Resources.BackerCenter.SectionUpdatesFeedHeader,
        size: "narrow",
        "current-view": "updates",
      },
    },
    [
      _c(
        "nav",
        { staticClass: "_flex _gap-2 _mb-5 _pt-4" },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "base-tab",
            {
              key: tab.key,
              attrs: {
                tag: "a",
                href: tab.url,
                title: tab.label,
                variant: "link",
                "is-active": tab.isActive,
                "data-qa": `updates-feed:${tab.label}`,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCategoryClick(tab.key)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _vm._l(2, function (n) {
            return _c("skeleton-update-feed-card", {
              key: n,
              attrs: { "data-qa": "updates-feed-skeleton" },
            })
          })
        : _vm.hasUpdates
        ? [
            _c("backer-center-update-feed-list", {
              attrs: { updates: _vm.mappedPagedItems },
            }),
            _vm._v(" "),
            _vm.isLoadMoreEnabled
              ? _c("load-more-trigger", {
                  on: { "load-more": _vm.loadMoreRows },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoadingMore ? _c("skeleton-update-feed-card") : _vm._e(),
          ]
        : _vm.isEmpty
        ? _c("backer-center-update-feed-empty-state")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }